const ProductSkeleton = () => {
  return (
    <div className="bg-white rounded-lg shadow-sm p-3 animate-pulse">
      <div className="bg-gray-300 h-40 w-full rounded"></div>

      <div className="mt-3 flex flex-col items-center">
        <div className="h-3 w-16 bg-gray-300 rounded mb-2"></div>
        <div className="h-3 w-24 bg-gray-300 rounded mb-2"></div>
        <div className="h-4 w-20 bg-gray-300 rounded mb-2"></div>

        <div className="h-9 w-full bg-gray-300 rounded mt-3"></div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
